import { message } from "antd";
import axios from "axios";
import { apiHeaders } from "../../helper/apiHeader";
import { getStudentData } from "../../helper/localStorage";

export const surveyListApi = (dispatchSurvey) => {

  const myData = {
    data: {
      player_id: getStudentData().login_id,
    },
  };

  dispatchSurvey({ type: "SURVEY_LOADER" })

  axios
    .post("/MetaData", myData, apiHeaders("surveylist"))
    .then((res) => {
      if (res.data.status === "201") {
        console.log(res.data.data);
        dispatchSurvey({ type: "SURVEY_LIST", payload: res.data.data })
      } else {
        message.error(res.data.msg)
        dispatchSurvey({ type: "SURVEY_ERR" })
      }
    })
    .catch(() => {
      // message.error("Please wait for sometime or check your internet connection. Try again")
      dispatchSurvey({ type: "SURVEY_ERR" })
    });
};
